import { createAction } from '@reduxjs/toolkit';
import type { FetchableResource } from '~/_shared/types/fetchableResource/fetchableResource';
import type { GeoLocation } from '~/_shared/utils/geolocation/geolocation';
import type { PlaceId } from '~/places/places.types';
import type { PlacesSearchId } from '~/store/mapSettings/places/mapSettingsPlaces.state';
import type { PlacesSearchResult } from './places.state';

export const frontendStatePlacesSetActivePlace = createAction(
  'FRONTEND_STATE_PLACES_SET_ACTIVE_PLACE',
  (placeId: PlaceId | null) => ({
    payload: { placeId },
  })
);

export const frontendStatePlacesPlacesSearchesSetLoading = createAction(
  'FRONTEND_STATE_PLACES_PLACES_SEARCHES_SET_LOADING',
  (searchIds: ReadonlySet<PlacesSearchId>) => ({
    payload: { searchIds },
  })
);

export const frontendStatePlacesPlacesSearchesRequestNextPage = createAction(
  'FRONTEND_STATE_PLACES_PLACES_SEARCHES_REQUEST_NEXT_PAGE_STATE',
  (searchIds: ReadonlySet<PlacesSearchId>) => ({
    payload: { searchIds },
  })
);

export const frontendStatePlacesSetPlacesSearchResults = createAction(
  'FRONTEND_STATE_PLACES_SET_PLACES_SEARCH_RESULTS',
  (results: ReadonlyMap<PlacesSearchId, FetchableResource<PlacesSearchResult>>) => ({
    payload: { results },
  })
);

export const frontendStatePlacesExpandSearch = createAction(
  'FRONTEND_STATE_PLACES_EXPAND_SEARCH',
  (id: PlaceId) => ({
    payload: { id },
  })
);

export const frontendStatePlacesCollapseSearch = createAction(
  'FRONTEND_STATE_PLACES_COLLAPSE_SEARCH',
  (id: PlaceId) => ({
    payload: { id },
  })
);

export const frontendStatePlacesSetStartingLocation = createAction(
  'FRONTEND_STATE_PLACES_SET_STARTING_LOCATION',
  (location: GeoLocation) => ({
    payload: { location },
  })
);

export const frontendStatePlacesSetHoveredSearch = createAction(
  'FRONTEND_STATE_PLACES_SET_HOVERED_SEARCH',
  ({ searchId }: { searchId: PlacesSearchId }) => ({
    payload: { searchId },
  })
);

export const frontendStatePlacesStopHoveredSearch = createAction(
  'FRONTEND_STATE_PLACES_STOP_HOVERED_SEARCH',
);
